import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DramaNarrativeExplorationFlow() {
  return <section data-section-id="257624" id="drama-narrative-exploration-flow" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image Column */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Decorative glow using accent color */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-primary/10 blur-[100px] rounded-lg pointer-events-none" />
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/drama_therapy_role_play.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/drama_therapy_role_play.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685908/img/drama_therapy_role_play.png-wvc-sizes" alt="戲劇治療中的角色扮演與情感探索" className="relative z-10 w-full max-w-md lg:max-w-full h-auto object-contain shadow-2xl rounded-lg" loading="lazy" />
          </div>

          {/* Content Column */}
          <div className="flex flex-col items-start space-y-8 max-w-xl">
            <div className="space-y-4">
              <span className="text-primary font-semibold tracking-widest uppercase text-sm font-default">
                故事與角色探索
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-light leading-tight text-foreground">
                在戲劇的 <span className="font-bold text-primary">安全容器中</span> 遇見自己
              </h2>
            </div>
            
            <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
              透過角色扮演與敘事流動，我們在虛構的故事中探索真實的情感。戲劇提供了一個受保護的空間，讓您能自由地實驗不同的生命姿態，轉化內在的敘事。
            </p>
            
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-6 text-base md:text-lg font-medium group mt-4 border-none shadow-lg shadow-primary/20">
              <Link to="/StoryAndCharactersDramaNarrativeExplorationPage">
                探索戲劇工作坊
                <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}